import * as React from 'react';
import { colors } from '../../../index';

const IconAttachment = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.895 1.065a3.604 3.604 0 00-5.096 0L.792 8.072A2.695 2.695 0 004 12.34a.446.446 0 00.294-.127l7.007-7.006a1.801 1.801 0 10-2.548-2.548L3.021 8.392a.45.45 0 00.637.637l5.733-5.733a.9.9 0 111.274 1.274l-6.689 6.688A1.801 1.801 0 111.43 8.711l7.006-7.009a2.702 2.702 0 113.823 3.823l-6.37 6.37a.45.45 0 00.637.636l6.37-6.37a3.604 3.604 0 000-5.096z"
  }));
};

export default IconAttachment;